module.exports = __webpack_public_path__ + "static/media/min.606b62b0.svg";